import settings from '@/config/settings';

import type {
  IApplication,
  IApplicationCreate,
  IApplicationFilter,
  IApplicationUpdate,
} from '@/api/types/application';

import useAPIHook from '@/assets/core/assets/hooks/APIHook';

const url = new URL(settings.SERVICES.BACK.getUrl() + '/applications');

export const applicationAPI = useAPIHook<
  IApplication,
  IApplication,
  IApplicationCreate,
  IApplicationUpdate,
  IApplicationFilter
>(url);
